module.exports = __webpack_public_path__ + "assets/rewind-circle.74fb971f.svg";